export enum AddAttendeesStep {
  ADD_ATTENDEES_TABLE = "addAttendeesTable",
  ADD_ATTENDEES_UNAVAILABLE = "addAttendeesUnavailable",
}
